<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Ανενεργοί Πελάτες</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showClient(item.id)"
            clickable-rows
          >
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #afm="{item}">
            <td>
              {{ getAfmText(item.afm) }}
            </td>
          </template>
          <template #active="{item}">
            <td>
              <CBadge :color="getBadge(item.active)">{{ getBadgeText(item.active) }}</CBadge>
            </td>
          </template>
          <template #services="{item}">
            <td>
              {{ item.services }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editClient( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import js2excel from 'js2excel';

const fields = [
  {
    key: 'company', 
    label: 'Εταιρία', 
    sorter: true, 
    filter: true
  },
  {
    key: 'afm', 
    label: 'ΑΦΜ', 
    sorter: true, 
    filter: true
  },
  {
    key: 'active', 
    label: 'Κατάσταση', 
    sorter: false, 
    filter: false
  },
  {
    key: 'services',
    label: 'Πρότυπα',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Clients',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      loading: true,
      alertIsShown: false,
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedIsoOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const services = item.services;

        return services.includes(this.selectedIsoOption);
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.filteredItems.map((item) => {
        return {
          Εταιρία: item.company,
          ΑΦΜ: item.afm,
          Κατάσταση: 'Ανενεργός',
          Πρότυπα: item.services
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'inactive-clients-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    getAfmText (afm) {
      if (!afm) {
        return '-';
      } else {
        return afm;
      }
    },
    getBadge (status) {
      return status ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status ? 'Ενεργός' : 'Ανενεργός'
    },
    clientLink (id) {
      return `clients/${id.toString()}`
    },
    editLink (id) {
      return `clients/${id.toString()}/edit`
    },
    showClient ( id ) {
      const clientLink = this.clientLink( id );
      this.$router.push({path: clientLink});
    },
    editClient ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    getServices (cases) {
      let serviceArray = cases.map((item) => {
        return item.name;
      });
      let services = serviceArray.join(", ");
      return services;
    },
    showAlert () {
      this.alertIsShown = true
    },
    getClients (){
      let self = this;
      axios.get('/api/clients/filteredInactiveClients' + '?active=0' + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.clients.map((item) => {
          item.services = self.getServices(item.services);
          return item;
        })
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    createClient () {
      this.$router.push({path: 'clients/create'});
    },
  },
  mounted: function(){
    this.getClients();

    let self = this;
    axios.get('/api/services?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.services = response.data.services.map((item) => {
        return item;
      });

      self.servicesOptions = ['Καμία επιλογή', ...new Set(self.services.map(item => item.name))];
      self.selectedIsoOption = self.servicesOptions[0];

    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}
</script>
